import { get } from '@/api/base'

export const getContainersForCompany = async companyUuid => {
  const response = await get({
    path: `admin/containers`,
    params: { company_uuid: companyUuid },
  })
  return response.success ? response.data.containers : []
}
